/**
 * Dados de contato centralizados
 * Fonte única de verdade para telefones, emails e redes sociais
 */

export const CONTACT = {
  phones: [
    { label: "(81) 98814-3087", raw: "5581988143087" },
    { label: "(81) 98733-7747", raw: "5581987337747" },
  ],
  emails: [
    "contato@x4payassessoria.com",
    "xaxa@x4payassessoria.com",
  ],
  whatsapp: {
    phone: "5581988143087",
    message: "Olá! Gostaria de saber mais sobre os serviços da X4PAY.",
  },
  social: {
    instagram: "https://www.instagram.com/x4pay_assessoria/",
    linkedin: "https://www.linkedin.com/company/x4pay-assessoria/",
  },
};
